// src/components/resume/ResumeExperience.js
import React from 'react';
import styles from '../../styles/pages/Resume.module.css';

/**
 * Resume experience item component for job experiences
 * 
 * @param {Object} props - Component props
 * @param {string} props.title - Job title
 * @param {string} props.company - Company name
 * @param {string} props.location - Job location
 * @param {string} props.period - Employment period
 * @param {string[]} props.responsibilities - List of job responsibilities
 */
export function ResumeExperience({ 
  title, 
  company, 
  location, 
  period, 
  responsibilities 
}) {
  return (
    <article className={styles.experienceItem}>
      <h3>{title}</h3>
      <p className={styles.companyInfo}>
        <strong>{company}</strong> | {location} | {period}
      </p>
      {responsibilities.map((item, index) => (
        <p key={index} className={styles.responsibility}>
          - {item}
        </p>
      ))}
    </article>
  );
}